// ENGLISH LANGUAGE RESOURCES
const RESOURCES = {
  WEBSITE: "RoboMaster.com",
  BBS: "RoboMaster BBS",
  CHANGE: "Change",
  DETAIL: "Details",
  STATUS: "Status",
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
  NOTIFICATION: "Notification",
  EDIT: "Edit",
  CANCEL_EDIT: "Completed",
  CHANGE_CHINESE: "中文",
  CHANGE_ENGLISH: "English",
  REGISTRATION_CENTER: "Registration",
  RETURN_REGISTRATION_CENTER: "Return to Registration Page",
  YOU_WILL_JOIN_IN: "You are about to join ",
  JOIN_IN: "taking part in ",
  CONTROL_CENTER: "Administration",
  RETURN_CONTROL_CENTER: "Return Control Center",
  MY_TEAMS: "My teams",
  MY_GAMES: "Register",
  EDIT_INFO: "Edit your profile",
  REGISTRATION_TIME_REMAINING: "Time till registration deadline",
  REGISTRATION_TIME_BEGIN: "Registration start time",
  APPLY_NOW: "Apply Now",
  GAME_TIME: "Competition Schedule: ",
  NEXT: "Next",
  COMPLETE_INFO: "GO Complete",
  PERSON_INFO_NOT_COMPLETE: "Complete your personal information",
  PERSION_NOTICE: "Please complete your personal information before continuing",
  CREATE_TEAM: "Create a team",
  CREATE_TEAM_SUCCESS: "Successfully Created",
  CREATE_TEAM_DESC: "创建一个战队，成为队长，招募队员，创造属于你们的辉煌",
  CREATE_TEAM_INFO: "Please create a team first if you are a team leader",
  JOIN_IN_TEAM: "Join This Team",
  JOIN_A_TEAM: "Join A Team",
  JOIN_A_DELIVERY: "立即投递",
  CONFIRM_THE_ENTRY_INFO: "Please confirm the entry information",
  CONFIRM_THE_ENTRY_INFO_TIPS:
    "Please provide accurate personal information for certificate preparation and on-site verification. Any inconsistency will affect your eligibility to the event.",
  COMPETITION: " competition",
  INVITATION_CODE_INFO: "Please contact the team leader of the team you wish to join",
  ENTER_INVITATION: "Enter invitation code",
  TEAM_NAME: "Team Name",
  GROUP_TYPE: "Team Type",
  TEAM_SCHOOL: "School Represented",
  CAMPUS_ORGANIZATION: "Superior School institution",
  INTRODUCTIONLINK: "Introduction Links",
  CAMPUS_ORGANIZATION_TIP:
    "The team’s superior institution or secondary teaching and research unit, such as the work training center/innovation center/college",
  INTRODUCTION_LINKS: "Introduction Links",
  INTRODUCTION_LINKS_TIP: `Please provide a link to your organization's introduction, starting with either "https://" or "http://". This link will be displayed publicly on the list.`,
  ADDRESSEE: "Recipient",
  ADDRESSEE_PHONE: "Recipient’s phone number",
  ADDRESSEE_ADRESS: "Delivery Address",
  YOUR_POSITION: "Your position",
  POSITION: "Position",
  YOUR_ROLE: "Your role",
  ROLE: "Role",
  YOUR_APPLY: "You have applied to join ",
  APPLY_SUCCESS: "Application Successful",
  YOU_CAN: "You can check the progress of your application or ",
  YOU_CAN2: "You can manage team information under ‘",
  VIEW_PROCESS: "view process",
  YOUR_ALSO: " under ",
  CANCEL_APPLY: "withdraw your application",
  YOU_APPLYED: "You have created ",
  YOU_INVITATION_CODE: "The invitation code for your team is ",
  CREATE_TEAM_SUCCESS_TIP: "Your team members may now register their accounts ",
  CREATE_TEAM_SUCCESS_TIP2:
    " and join the team by using this invitation code. Please keep the invitation code secure and confidential.",
  CANTROL_YOUR_TEAM: " ’",
  GAME_CONTROL: "Competition",
  GAME_TYPE: "Competition Type",
  CAPTAIN: "Captain",
  MY_POSITION: "My Position",
  VIEW: "Refer To",
  ENTRY_PROJECT: "Competition category",
  ENTRY_PROJECT_EMPTY_TIP: "Competition Category is required",
  PLEASE_ENTER_CAMPUS_ORGANIZATION: "Campus Organization is required",
  CHANGE_INVITATION_CODE: "Change Invitation Code",
  APPLY_GAME: "Confirmation of enrollment",
  TEAM_MEMBERS: "Team Member",
  CURRENT_SCHOOL: "University",
  START_YEARL: "Enrollment year",
  MAJOR: "Major",
  KICK_OUT: "Remove",
  TEACHER: "teacher-mentor",
  ADVISER: "consultant",
  PROJECT_MANAGER: "project manager",
  PROMOTION_MANAGER: "publicity manager",
  TEAM_MEMBER: "team member",
  INVITATION_TIP: "The original invitation code will no longer be valid",
  DETAIL_INFO: "Detail>",
  PACK_UP: "Pick Up",
  PASS: "Pass",
  PASSED: "Passed",
  UPLOAD_HISTORY: "Submission record",
  VIEW_MORE: "..Find out more",
  ADDRESSEE_TIP:
    "Road name or street address, house number (zip code is needed for overseas address) ",
  SCHOOL_NAME: "University Name (Full name)",
  SCHOOL_NAME_EMPTY_TIP: "University Name is required",
  SCHOOL_NAME_SHORT: "University Name (Abbreviation)",
  SCHOOL_NAME_AREA: "Location",
  SCHOOL_NAME_AREA_EMPTY_TIP: "Location is required",
  SCHOOL_TIP: "Type and select from matching options",
  CREATE_TEAM_LOGO_TIP: "Image format: 800*800px transparent background .png",
  CREATE_TEAM_LOGO_TIP_SIZE:
    "The size of the picture does not meet the requirements, please upload it again",
  CREATE_TEAM_LOGO_TIP_ERROR: "Upload failed, please upload again",
  CREATE_TEAM_LOGO_TIP_TYPE: "Upload file type error, please upload again",
  CREATE_TEAM_LOGO_TIP_LARGE: "The image size does not meet the requirements, please re-upload it",
  TEAM_LOGO_EMPTY_TIP: "University Logo is required",
  TEAM_IS_LOCKED: "Team has been locked in",
  AGREE_TERMS: "I have read and agree to the above terms and conditions",
  TEAM: " team",
  CONSORTIUM: "consortium",
  INVALID_INVITATION_CODE:
    "Invalid invitation code. Please confirm with the team leader of the team you wish to join",
  WRONG_INVITATION_CODE:
    "The invitation code you entered does not match with the {key-0} competition, please visit the {key-0} competition information site and sign up accordingly.",
  IS_END: "ENDED",
  PLEASE_ENTER_TEAM_NAME: "Team Name is required",
  WRONG_PHONE: "Wrong format Phone Number",
  EMPTY_PHONE: "Recipient’s phone number is required",
  TEAM_SCHOOL_EMPTY_TIP: "School Represented is required",
  TEAM_NAME_TIP:
    "Team name should not include school name or its abbreviation, “team” or special characters such as “*/-+”. The first character of the name should be capitalized and the total characters including spaces should be no more than 16 characters. ",
  TEAM_ABBREVIATION_TIP:
    "No more than 16 characters (2 characters for each Chinese character and 1 character for each English alphabet)",
  EMPTY_RECIPIENT: "Name of recipient is required",
  EMPTY_ADDRESS: "Delivery Address is required",
  OTHER_SCHOOL: "Can’t find your school?",
  EMPTY_SCHOOL_SHORT: "University Name (Abbreviation) required",
  REGISTRATION: "Registration",
  REJECT: "Reject",
  APPLICANT_LIST: "candidate lists",
  APPLICANT_LIST_NUM: "candidate lists ({key-0})",
  EDIT_TEAM_INFO: "Edit team data",
  COLLEGES_INFO: "Schools Infomation",
  UPDATE_TEAM: "Update",
  NOT_BEGIN: "NOT BEGIN",
  COMFIRM_CANCEL: "Are you sure you want to cancel your application?",
  COMFIRM_CANCEL_DETAIL: "The team will not receive your application after you cancel it",
  LOCKED: "Locked",
  UNLOCKED: "Unlocked",
  TEAM_GAME: "Team Game",
  PERSON_GAME: "Individual Game",
  TEAM_LOCK_DESC1: " has submitted the registration of ",
  TEAM_LOCK_DESC2:
    ". Information of the team and members will be locked and cannot be modified. During the preparation period, the system will be open for modifications again. Please look out for the official announcement for further details.",
  TEAMMEMBER_LIST: "team member",
  TEAMMEMBER_LIST_NUM: "team member ({key-0})",
  EXIT_TEAM: "quit",
  NOW_MEMBER_NUM: "members",
  CONFIRM_TIP:
    "After submitting the registration, information of the team and members will be locked and cannot be modified. During the preparation period, the system will open for modification again. Please pay attention to the official announcement.",
  MEMBER_INVALID:
    "Please check that the member information is complete. Otherwise, you will not be able to sumbit.",
  CONFIRM_MEMBER_TIP_TITLE: "Information cannot be changed after confirmation",
  CONFIRM_MEMBER_TIP:
    "Team information will be used for the subsequent competition live presentation, certificate production, click to confirm the information will not be changed.",
  CONFIRM_MEMBER_WARN:
    "Please note that all changes will be effective immediately. The RoboMaster Organizing Committee will review the most recent submission, please submit information timely.",
  CONFIRM_SUBMIT: "Registration confirmation",
  SHOW_ALL_MEMBERS: "View all team members",
  REGISTRATION_CODE_GET: "Registration number",
  CHANGE_CAPTAIN: "Change team leader",
  CHANGE_CAPTAIN_TIP:
    "Are you sure you want to give up your role as a leader? If yes, you will become a team member without any management authorization.",
  DELETE_TEAM: "Disband team",
  DELETE_TEAM_TIP: "All team data will be deleted and cannot be recovered",
  DELETE_TEAM_CONFIRM: "Confirm",
  TEAM_MEMBER_MISSING_TITLE: "Provided team information does not fulfil registration requirements:",
  TEAM_MEMBER_REQUIRED: "Requirements:",
  TEAM_MEMBER_REQUIRED_1: "1、Provided team information must be complete;",
  SELECT_FILE: "Choose file",
  REGISTRATION_CODE: "Application Number",
  ENGLISH_NAME: "English Name: ",
  FAIL: " Fail",
  FAILED: " Failed",
  INVALID_CHAR: "Invalid character",
  MUST_BE_CAP: "The first character of the name should be capitalized",
  CHAR_LIMIT: "exceeds the character limit",
  ILLEG_CHAR: "contains illegal characters",
  SUBMIT_LIMIT: "closed",
  SUBMIT_LIMIT_CUR: "closed",
  FILE_SIZE_LIMIT: "The file size exceeds the limit.",
  ENTTRY_TEAM: "Contest Agreement",
  RECRUITMENT_INSTRUCTIONS: "Recruitment Instructions",
  ENTER_INVITATION_TIP: "Please input your invitation Code",
  CONFIRM_SUBMIT_FORM: "Are you sure want to submit",
  WELCOME: "Welcome",
  PERSON_CENTER: "Profile Page",
  CHANGE_PASSWORD: "Change Password",
  LOGOUT: "Logout",
  LOGIN: "Login",
  REGISTER: "Register",
  // PREPARATION_COMPLETE: "备赛完成",
  // PREPARATION_COMPLETE_TIP1: "恭喜您顺利完成备赛流程，祝您的战队在",
  // PREPARATION_COMPLETE_TIP2: "中取得好成绩！",
  RETURN_GAME_APPLY: "Back",
  IS_COMPLETED: "You have completed the preparation work. Good luck on the competition!",
  FINAL_REGION: "The final region",
  MESSAGE_CENTER: "Notifications",
  IS_CLOSED: "closed",
  LAST_TIME: "Submission Time",
  EXAM_STATUS: "Exam Status",
  EXAM_STATUS_TIP:
    "Exam Result are based on your final exam score and will be released before 2:00pm Nov.7th 2018 (CCT).",
  CANNOT_THE_SAME:
    "Competition Region - First Choice and Competition Region - Second Choice cannot be the same.",
  START_EVALUATION: "Enter exam",
  IS_REQUIRED: "{key-0} is required",
  IS_REQUIRED_INPUT: "{key-0} is required",
  COPY_TEAM: "Copy Team History",
  COPY_TEAM_TIP:
    "Below is the complete information about teams that you have joined, please select the team you want to copy.",
  JUAGE_SCORE_LAST:
    "Status: Determined by the final exam result (the latest score after Rules Exam)",
  JUAGE_SCORE_HIGHEST:
    "Status: Determined by the final exam result (the highest score after Rules Exam)",
  EVENTS_CONTROL: "Events",
  EVENTS_NAME: "Event Name",
  CURRENT_STAGE: "Stage",
  CURRENT_STATUS: "Status",
  ABNORMAL_DATA: "Abnormal Data",
  SUBMIT: "Submit",
  MEETING_IS_FULL: "(Full)",
  CHOOSE_DATE: "Choose Date",
  CHOOSE_TIME: "Choose Time",
  RESERVATION_TIME: "Appointment Time",
  INTERVIEW_TIME: "Time",
  INTERVIEW_DATE_REQUIRE: "The interview date is required.",
  INTERVIEW_TIME_REQUIRE: "The interview time is required.",
  CONFIRM_SUBMIT_MEETING:
    "Please confirm your submission of the interview time. Once submitted, the interview time cannot be modified.",
  ADD_UNITED_SCHOOL: "Add your school",
  KICK_OUT_TITLE: "Delete this team member?",
  KICK_OUT_TIP:
    "Warning: This cannot be undone. If the team member wants to rejoin the team, he needs to resubmit the application within the valid registration period.",
  KICK_OUT_CONFIRM: "Confirm",
  KICK_OUT_CANCEL: "Cancel",
  AREA: "Country/Province/City/ District and County",
  ADD_UNITED_SCHOOL_TIP: "You can add up to five schools",

  USER_TITLE: "User",
  XP_TITLE: "Experience",
  AGE_TITLE: "Age",
  APP_DESCRIPTION: "React Create App with React Router and MobX and Internationalization.",
  ACTIONS: {
    INCREASE_XP: "Increase Experience Points!",
    CHANGE_NAME: "Change My Name!",
    CHANGE_LASTNAME: "Change My Last Name!"
  },
  MUTI_SCORE: "Score",
  MUTI_SUBMIT_TIME: "Submit Time",
  MUTI_STATUS: "Status",
  MUTI_END_TIME: "This round ends in",
  MUTI_PENDING_STATUS: "Please refresh to get the result.",
  MUTI_ERROR: "Server is busy now, please try again later.",
  SERVER_ERROR_NEED_LOGIN:
    "Login failed and your apply was denied.It might be the reason you've logined through another window.We will refresh your screen  after your confirmation and please try once more.",
  SERVER_ERROR_VALIDATE_FAILED:
    "Login failed and your apply was denied.It might be the reason you've logined  another window.We will refresh your screen  after your confirmation and please try once more.",
  AUTHORISATION_TITLE: "Authorisation",
  AUTHORISATION_NOTICE:
    "You can select one team member to help manage the team.\nThis person can modify the team information, disband the team, change the invitation code, modify the role and position of a member, kick out a member, manage the application of a member to join the team, as well as register for the competition and have the right to submit materials for all sections of the registration process (except the exam section). \nYou can also revoke this person's administrative authority.",
  AUTHORISATION_DIALOG_TITLE: "Authorise this member？",
  AUTHORISATION_DIALOG_DESC:
    "You can have one more team member managing your team by giving this authorisation. It can be canceled if you want.",
  AUTHORISATION_DIALOG_CONFIRM: "Confirm",
  AUTHORISATION_DIALOG_CANCEL: "Cancel",
  AUTHORISATION_FAILED: "Authorisation failed.Please try again.",
  AUTHORIZE: "Authorise",
  AUTHORISE_CANCEL: "Cancel",
  UPDATE_SUCCESS: "Registration success!",
  COMPLETE_PROMPT_MESSAGE:
    "Participants participating in the Mecha Masters Contest、 Single Event、 Artificial Intelligence Challenge, please download and read the registration guidelines carefully.",
  PROMPT_MESSAGE:
    "Participants participating in the RoboMaster University Series, please download and read",
  REGISTRATION_GUIDELINES: "the registration guidelines",
  // COMPLETE_PROMPT_MESSAGE_SECOND: 'Participants participating in the Mecha Masters Contest、 Single Event、 Artificial Intelligence Challenge, please download and read the registration guidelines carefully.',
  PROMPT_MESSAGE_SECOND:
    "Participants participating in the Mecha Masters Contest、 Single Event、 Artificial Intelligence Challenge, please download and read",
  REGISTRATION_GUIDELINES_SECOND: "the registration guidelines",
  PERIOD: "carefully.",
  PERIOD_SECOND: "carefully.",
  LOADING: "Loading...",
  DOCKER_UPLOAD: "File uploading, please wait ...",
  DOCKER_UPLOAD_SUCCEED: "Upload successful",
  DOCKER_UPLOAD_FAILED: "Upload failed",
  DOCKER_UPLOAD_SUCCEED_INFO:
    "The program has entered the execution queue. You can view the results in the submission record",
  DOCKER_UPLOAD_CANCEL: "Cancel upload",
  DOCKER_UPLOAD_AGAIN: "Upload again",
  DOCKER_UPLOAD_INFO_1: `若当前程序执行状态为“优先队列 排队中”或“普通队列 排队中”，重新上传将会导致该状态变更为“已取消”，新上传的程序会重新进入排队序列。 `,
  DOCKER_UPLOAD_INFO_2: `Please keep the webpage stable. If the upload is interrupted accidentally, you can re select the same file and resubmit it. The original upload progress will not be lost.`,
  IS_CANCEL_UPLOAD_DOCKER: "Please confirm whether you want to cancel uploading.",
  CLOSE: "Close",
  DOCKER_UPLOAD_FAILED_INFO: "Failure reason: {key-0}",
  TEAM_INFO: "Team information",
  PERSONAL_INFO_NOT_CHECKED: "Information verification failed",
  UPDATE_PERSONAL_INFO: "Click to enter the Personal Center and modify your information",
  PERSONAL_INFO_VERFICATION_FAILED: "Your information does not meet the verification requirements",
  CHANGE_PERSONAL_INFO: "Modify personal information",
  PERSONAL_INFO_ALERT:
    "Please make sure the information you provide is correct, otherwise it will affect the progress of the process.",
  NAME: "Name",
  CHINESE_NAME: "Chinese name",
  PHONE_NUMBER: "Phone",
  EMAIL: "E-mail",
  H_EDUCATION: "The last degree",
  H_SCHOOL: "The last college name",
  H_COLLEGE: "The last institute name",
  H_MAJOR: "The last major",
  H_START_TIME: "The last education begin time",
  H_END_TIME: "The last education end time",
  ENTER: "please enter ",
  SELECT: "please select ",
  WRONG_EMAIL: "Wrong format Email",
  CLICK_TO_LOAD_MORE: "Click to load more",
  CLICK_TO_CLOSE: "Click to close",
  CLICK_TO_UPDATE_PERSONAL_INFO: "Click to update personal information",
  BACK: "back",
  CONFIRM_INFO_IS_OK: "I promise that the information is correct",
  H_EDUCATION_ERROR_TIPS_0:
    "The undergraduate experience time is shorter than 4 years. Please confirm whether the academic time is correct",
  H_EDUCATION_ERROR_TIPS_1:
    "The undergraduate experience time is longer than 4 years. Please confirm whether the academic time is correct.",
  H_EDUCATION_ERROR_TIPS_2:
    "The master's degree duration is longer than 3 years. Please confirm whether the degree duration is correct.",
  H_EDUCATION_ERROR_TIPS_3:
    "The master's degree duration is 0. Please confirm whether the degree duration is correct.",
  H_EDUCATION_ERROR_TIPS_4:
    "The doctor's degree duration is longer than 6 years. Please confirm whether the degree duration is correct.",
  H_EDUCATION_ERROR_TIPS_5:
    "The doctor's degree duration is shorter than 3 years. Please confirm whether the degree duration is correct.",
  SCHOOL_FULL_NAME_ZH: "Full name of the school in Chinese",
  SCHOOL_SHORT_NAME_ZH: "School abbreviation in Chinese",
  SCHOOL_FULL_NAME_EN: "Full name of the school in English",
  SCHOOL_SHORT_NAME_EN: "School abbreviation",
  SCHOOL_ADDRESS: "Country/province/city",
  SCHOOL_COUNTRY: "Country",
  UPDATE_SCHOOL_INFO: "Updating School Information",
  SCHOOL_FULL_NAME_CAN_NOT_EMPTY:
    "The full name of the school in English and Chinese cannot be left blank.",
  SCHOOL_SHORT_NAME_ZH_LIMIT: "请控制在8个汉字以内",
  SCHOOL_SHORT_NAME_EN_LIMIT: "请控制在16个英文字母以内",
  COUNTRY: "Country",
  SAVE: "Save",
  SCHOOL_BADGE: "schoolBadge",
  CLICK_TO_SELECT_FILE: "Click to select a file",
  UPLOAD_SCHOOL_BADGE_TIPS: "Limit .png transparent background files within 1MB, size 800 * 800px",
  SCHOOL_BADGE_FORMATS: "File specification",
  SCHOOL_BADGE_LARGE: "File size",
  SCHOOL_BADGE_SIZE: "Image dimensions",
  SCHOOL_BADGE_FETCH_ERROR: "Failed to get the school logo, please refresh the page and try again.",
  SCHOOL_BADGE_ERROR: "The school logo does not meet the requirements, please re-upload",
  UPDATE_SCHOOL_INFO_ERROR:
    "Failed to save school information, please refresh the page and try again.",
  UPDATE_SCHOOL_INFO_ERROR_EXISTING: "Failed to save school information, school already exists.",
  UPDATE_SCHOOL_INFO_SUC: "Updating school information is successful.",
  VERIFY_SCHOOL_BADGE_FORMATS:
    "School logo file format is not png, please update the school information",
  VERIFY_SCHOOL_BADGE_LARGE:
    "If the school logo file size is larger than 1MB, please update the school information.",
  VERIFY_SCHOOL_BADGE_SIZE:
    "School logo file size is not 800px * 800px, please update your school's information.",
  CONFIRM_INFO: "Confirmation information",
  TEAM_INFO_NOT_CONFIRMED: "Team information not confirmed",
  TEAM_INFO_NOT_CONFIRMED_DETAILS:
    "Please confirm the team information, school information and player information, click to confirm the information to continue the link operation",
  ADD_SCHOOL_INFO: "Add School",
  ADD_SCHOOL_INFO_ERROR: "Adding a school failed, please try again later.",
  ADD_SCHOOL_INFO_ERROR_EXISTING: "Failed to add school, school already exists.",
  TEAM_SLOGAN: "Team Slogan",
  TEAM_SLOGAN_TIPS:
    "Please adopt a positive slogan that highlights the team's culture. The slogan will be used for subsequent live broadcasts of matches and related activities.",
  UPDATE_PERSONAL_INFO_CONFIM_TIPS:
    "You are updating your school information, which will be used for the subsequent live presentation of the competition and the production of award certificates, the information will not be changed after clicking on the confirmation, so please proceed with caution.",
  SELECT_TEAM: "Select the competing team",
  SELECT_TEAM_TIPS: "After selection, this team will participate in the {key-0}",
  CONFIRM_REGISTRATION_INFO: "Confirmation of registration information",
  CREATE_TEAM_BBS_TIPS1: "Information confirmation will complete the season registration, ",
  CREATE_TEAM_BBS_TIPS2: "team information does not support modification this season",
  CREATE_TEAM_BBS_TIPS3:
    " please operate with caution. The specific entry list will be collected in the subsequent session, please pay attention to the tournament announcement and notification.",
  APPLY_TIPS_BBS:
    "Please contact your team leader or instructor to register, or contact RoboMaster High School Tournament Services for entry guidelines. (Micro signal: rmsaiwu)",
  ENTRY_LIST_TIPS:
    "*The list of entries will be collected subsequently, so keep an eye out for the notification.",
  PLEASE_ENTER_TEAM_SLOGAN: "The team slogan cannot be empty.",
  WRONG_TEAM_SLOGAN: "Please enter the correct team slogan",
  TEAM_SLOGAN_TOOL_TIP_TEXT:
    "The maximum number of characters for the team slogan is 40. There are 2 characters for Chinese, 2 characters for Chinese punctuation, 2 characters for lowercase English letters, 2 characters for uppercase English letters, 1 character for English punctuation, and 1 character for spaces.",
  CONFIRM_TEAM_INFO: "Confirmation of entry information",
  SUBMIT_ENTRY_LIST: "Submit a list of official team members, teachers and advisors",
  SUBMIT_RESERVE_LIST: "Submit the echelon team member list",
  COLLECTION_LIST_NEXT_TIPS:
    "Note: The organising committee will review the list of entries after clicking Next and submitting the list of entries, please pay attention to the announcement on the official website to see if the entries are successful or not.",
  ENTRY_LIST: "entry list",
  DIRECTION: "direction",
  NO_DATA: "No data"
};

export default RESOURCES;



// WEBPACK FOOTER //
// ./src/language/i18n/en.js